import { render, staticRenderFns } from "./image-size.vue?vue&type=template&id=5a8db332"
import script from "./image-size.vue?vue&type=script&lang=ts"
export * from "./image-size.vue?vue&type=script&lang=ts"
import style0 from "./image-size.vue?vue&type=style&index=0&id=5a8db332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports